<template>
  <div>
    <b-modal :title="'مدیریت صدور مدرک'" id="skillUpCertificateModal" v-model="showModal" no-close-on-esc header-close-variant="dark" hide-footer centered>
      <div class="__context">
        <div style="width: 286px !important">
          <div class="d-flex gap-2">
            <p v-text="'تعداد اعضا :'" />
            <span class="text-primary">{{ selectedCertificate.NumberOfPeople || '--' }}</span>
            <span v-text="'نفر'" />
          </div>

          <div class="d-flex gap-2">
            <p v-text="'تاریخ : '" />
            <span>{{ convertDate(selectedCertificate.StartDate, 'fa') }}</span>
          </div>

          <div>
            <span v-text="selectedCertificate.Title" />
          </div>
        </div>

        <div style="width: 280px !important">
          <div class="d-flex gap-2">
            <p v-text="'شماره مجوز : '" />
            <span>{{ selectedCertificate.Code }}</span>
          </div>

          <div class="d-flex gap-2">
            <p v-text="'Date :'" />
            <span>{{ convertDate(selectedCertificate.StartDate, 'fa') }}</span>
          </div>

          <div>
            <span v-text="selectedCertificate.EnglishTitle" />
          </div>
        </div>
      </div>

      <hr />

      <div class="mt-4 d-flex">
        <BaseText
          v-if="checkPeopleHasLicense && checkPeopleHasLicense.peopleId"
          v-model="number"
          @input="setStepNumber"
          title="شماره گواهی از  "
          placeholder="شماره"
          style="width: 284px"
          required
          :errortext="numberError || errorText"
          :showError="(submit && !number) || numberError.length"
        />
        <BaseText
          v-else
          v-model="number"
          @input="setNumber"
          title="شماره گواهی از  "
          placeholder="شماره"
          style="width: 284px"
          required
          :errortext="numberError || errorText"
          :showError="(submit && !number) || numberError.length"
        />

        <div class="__certificate_number gap-2">
          <p v-text="' تا  '" />
          <p v-text="numberOfCertificate[1]" />
        </div>
      </div>

      <div class="w-100 mt-2">
        <ComboBox
          :searchedData="formatType"
          title="قالب"
          placeholder="قالب"
          :selectedValue="selectedFormat"
          @select="fillSelectedModel"
          :inputStyle="comboStyle"
          required
          :errortext="errorText"
          :showError="submit && !selectedFormat.length"
        />
      </div>

      <div class="d-flex justify-content-end align-items-center mt-3 gap-2">
        <b-button variant="secondary" @click="$bvModal.hide('skillUpCertificateModal')">انصراف</b-button>
        <b-button @click="printCertificate" class="upload-btn">
          <div>
            <span> ساخت مدارک </span>

            <i v-if="loading" class="fas fa-spinner fa-spin"></i>
          </div>
        </b-button>

        <b-button
          @click="downloadCertificate"
          :class="[
            'upload-btn',
            { 'download-btn': !checkPeopleHasLicense.hasLicense || downloadLoading },
            { disable: !checkPeopleHasLicense.hasLicense || downloadLoading || !selectedFormat.length || !number },
          ]"
        >
          <span> دانلود مدارک </span>

          <i v-if="downloadLoading" class="fas fa-spinner fa-spin"></i>
        </b-button>
      </div>
    </b-modal>

    <b-modal :title="'درخواست مجدد صدور مدرک'" id="AdminWarning" v-model="showAdminWarningModal" no-close-on-esc header-close-variant="dark" hide-footer centered>
      <p style="color: rgba(244, 106, 106, 1)">
        {{
          ` ادمین گرامی، برای این ${checkPeopleHasLicense.peopleId ? 'کاربر' : 'کاربران'} مدرک صادر شده است چنانچه خواهان چاپ مجدد مدارک برای ${
            checkPeopleHasLicense.peopleId ? 'کاربر' : 'کاربران'
          } هستید، روی دکمه ساخت مدرک کلیک
        کنید ( در نظر داشته باشید که ${checkPeopleHasLicense.peopleId ? 'مدرک' : 'مدرک های'} جدید جایگزین ${checkPeopleHasLicense.peopleId ? 'مدرک' : 'مدرک های'} قبلی خواهد شد).`
        }}
      </p>

      <div class="d-flex justify-content-end align-items-center mt-3 gap-2">
        <b-button variant="secondary" @click="$bvModal.hide('AdminWarning')">انصراف</b-button>
        <b-button @click="$bvModal.hide('AdminWarning'), (printAgain = true), printCertificate()" class="upload-btn">
          <div>
            <span> ساخت مجدد مدارک </span>

            <i v-if="loading" class="fas fa-spinner fa-spin"></i>
          </div>
        </b-button>
      </div>
    </b-modal>
    <div>
      <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :preview-modal="true"
        :filename="`from ${number} to ${numberOfCertificate[1]}`"
        :pdf-quality="2"
        html2canvas="{ scale: 1, scrollY: 0 ,scrollX:0}"
        pdf-format="a4"
        :pdf-orientation="selectedFormat === 'افقی' ? 'landscape' : 'portrait'"
        @progress="onProgress($event)"
        @hasStartedGeneration="hasStartedGeneration()"
        @hasGenerated="hasGenerated($event)"
        ref="html2Pdf"
        :paginate-elements-by-height="1400"
        :manual-pagination="false"
        pdf-content-width="100%"
      >
        <CertificateVertical slot="pdf-content" v-if="selectedFormat === 'عمودی'" :peopleLicense="checkPeopleHasLicense" :downloadedData="downloadedData" />

        <CertificateHorizontal slot="pdf-content" v-if="selectedFormat === 'افقی'" :peopleLicense="checkPeopleHasLicense" :downloadedData="downloadedData" />
      </vue-html2pdf>
    </div>
  </div>
</template>

<script>
import moment from 'jalali-moment'
import VueHtml2pdf from 'vue-html2pdf'
import CertificateVertical from './CertificateVertical.vue'
import CertificateHorizontal from './CertificateHorizontal.vue'
import BaseText from '../../common/form/formModules/BaseText.vue'
import ComboBox from '../../common/form/formModules/ComboBox.vue'
import skillUpIssuanceCertificate from '../../../services/skillUp/issuanceOfACertificate'

export default {
  name: 'PrintCertificatesModal',
  components: { BaseText, ComboBox, CertificateVertical, CertificateHorizontal, VueHtml2pdf },
  props: {
    licenseDataDownloaded: { type: Array, required: false },
  },

  data: () => {
    return {
      message: '',
      number: null,
      submit: false,
      loading: false,
      numberError: '',
      showModal: false,
      printAgain: false,
      downloadedData: [],
      selectedFormat: '',
      numberOfMember: null,
      showModalOnce: false,
      downloadLoading: false,
      downloadDisabled: true,
      selectedCertificate: {},
      numberOfCertificate: [],
      downloadedCertificate: [],
      checkPeopleHasLicense: {},
      printCertificateRequest: '',
      comboStyle: 'color: #495057',
      showAdminWarningModal: false,
      createCertificateRequest: false,
      value: undefined,
      errorText: 'وارد کردن این فیلد الزامی است',
      formatType: [
        { key: 0, value: 'عمودی' },
        { key: 1, value: 'افقی' },
      ],
    }
  },

  methods: {
    setNumber() {
      this.numberOfCertificate[0] = Number(this.number)
      this.numberOfCertificate[1] = Number(this.number) + Number(this.selectedCertificate.NumberOfPeople)
      console.log(this.numberOfCertificate[0], this.numberOfCertificate[1])
    },
    setStepNumber() {
      this.numberOfCertificate[0] = Number(this.number)
      console.log(this.numberOfCertificate)
      if (this.number) this.numberOfCertificate[1] = Number(this.number) + 1
    },
    convertDate(date, local) {
      if (!date) return '--'
      let finalTime = moment(date).locale(local).format('YYYY/M/D')
      return finalTime
    },
    fillSelectedModel(e) {
      this.selectedFormat = this.formatType.find((t) => t?.value === e)?.value
    },
    async downloadCertificate() {
      try {
        this.loading = true
        const req = await skillUpIssuanceCertificate.downloadCertificate({
          id: +this.$route.params.courseId,
          peopleId: this.checkPeopleHasLicense.peopleId ? +this.checkPeopleHasLicense.peopleId : undefined,
        })
        this.loading = false
        if (req.status === 200) {
          this.downloadedData = req.data.data.output
          this.$refs.html2Pdf.generatePdf()
        }
      } finally {
        this.loading = false
        this.printAgain = false
      }
    },
    async printCertificate() {
      this.numberError = ''
      if (this.checkPeopleHasLicense && this.checkPeopleHasLicense.hasLicense) {
        if (this.printAgain) {
          this.createCertificateRequest = true

          const state = {
            number: Number(this.number),
            selectedFormat: this.selectedFormat,
            createCertificateRequest: this.createCertificateRequest,
            NumberOfPeople: this.selectedCertificate.NumberOfPeople,
            courseId: this.$route.params.courseId,
          }

          localStorage.setItem('printInformation', JSON.stringify(state))
          this.submit = true
          if (!this.number || !this.selectedFormat?.length) {
            return false
          }
          this.downloadDisabled = true
          try {
            this.loading = true
            const req = await skillUpIssuanceCertificate.applyCertificate({
              number: this.numberOfCertificate[1],
              courseId: this.$route.params.courseId,
              peopleId: this.checkPeopleHasLicense.peopleId,
            })

            this.loading = false

            this.printCertificateRequest = req.data.data.output
            this.downloadDisabled = true
            this.downloadLoading = true
            setTimeout(() => {
              this.downloadDisabled = false
              this.downloadLoading = false
            }, 20000)
          } catch (error) {
            this.loading = false
            this.createCertificateRequest = false

            this.numberError = error.response.data.message
          }
        } else this.$bvModal.show('AdminWarning')
      }
    },
  },
  updated() {
    setTimeout(() => {
      this.checkPeopleHasLicense = JSON.parse(window.localStorage.getItem('checkHasLicense'))
    }, 1000)
  },
  mounted() {
    const newState = JSON.parse(localStorage.getItem('printInformation'))
    if (newState && newState.courseId === this.$route.params.courseId) {
      this.number = newState.number
      this.selectedFormat = newState.selectedFormat
      this.createCertificateRequest = newState.createCertificateRequest
      this.selectedCertificate.NumberOfPeople = newState.NumberOfPeople
      this.setNumber()
    }

    this.selectedCertificate = JSON.parse(localStorage.getItem('certificateInformation'))
  },
  watch: {
    checkPeopleHasLicense(value) {
      if (value && value.peopleId) this.setStepNumber()
    },
    showModal(val) {
      if (!val) {
        this.number = null
        this.numberOfCertificate = []
        this.submit = false
        this.numberError = ''
      }
    },
    deep: true,
  },
}
</script>

<style lang="scss" scoped>
.__context {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}

.__context p {
  color: #999696;
}

.__input {
  min-width: 10px !important;
}

.__certificate_number {
  margin: 0.5rem 1rem;
  display: flex;
}

.upload-btn {
  margin-right: 10px !important;
  background: #556ee6 !important;
  border-radius: 4px !important;
  color: white !important;
  padding: 8px 28px !important;
}

.download-btn {
  margin-right: 10px !important;
  background: #585b69 !important;
  border-radius: 4px !important;
  color: white !important;
  padding: 8px 28px !important;
}

._download_btn {
  margin-right: 10px !important;
  background: #556ee6 !important;
  border-radius: 4px !important;
  color: white !important;
  padding: 8px !important;
}
.disable {
  background: #556ee6 !important;
  pointer-events: none;
  border-color: #556ee6 !important;
  opacity: 0.5;
}

::v-deep .modal-content {
  border-radius: 16px !important;
  width: 120% !important;
}

::v-deep #AdminWarning .modal-dialog {
  position: relative;
  left: 25%;
}

::v-deep #AdminWarning___BV_modal_content_ {
  position: absolute;
  bottom: 0;
  right: 0 !important;
}
</style>
